<template>
  <div class=" fixed z-10  inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity" aria-hidden="true">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>

      <!-- This element is to trick the browser into centering the modal contents. -->
      <span
        class="hidden sm:inline-block sm:align-middle sm:h-screen"
        aria-hidden="true"
        >&#8203;</span
      >

      <div
        class="w-full sm:w-7/12 inline-block bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <div class="p-4">
          <v-data-iterator
            :items="messages"
            :items-per-page.sync="itemsPerPage"
            :page.sync="page"
            :search="search"
            :sort-by="sortBy.toLowerCase()"
            :sort-desc="sortDesc"
            hide-default-footer
          >
            <template v-slot:header>
              <v-toolbar dark color="blue darken-3" class="mb-1">
                <v-text-field
                  v-model="search"
                  clearable
                  flat
                  solo-inverted
                  hide-details
                  prepend-inner-icon="mdi-magnify"
                  label="Search"
                ></v-text-field>
                <template v-if="$vuetify.breakpoint.mdAndUp">
                  <v-spacer></v-spacer>
                  <v-select
                    v-model="sortBy"
                    flat
                    solo-inverted
                    hide-details
                    :items="keys"
                    prepend-inner-icon="mdi-magnify"
                    label="Sort by"
                  ></v-select>
                  <v-spacer></v-spacer>
                  <v-btn-toggle v-model="sortDesc" mandatory>
                    <v-btn large depressed color="blue" :value="false">
                      <v-icon>mdi-arrow-up</v-icon>
                    </v-btn>
                    <v-btn large depressed color="blue" :value="true">
                      <v-icon>mdi-arrow-down</v-icon>
                    </v-btn>
                  </v-btn-toggle>
                </template>
              </v-toolbar>
            </template>

            <template v-slot:default="props">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    block
                    class="my-1 sm:my-0"
                    color="#EEEEEE"
                    v-bind="attrs"
                    v-on="on"
                  >
                    Hover Me
                  </v-btn>
                </template>
                <span
                  >Cards with this background color do not have deliver date and
                  no repeated</span
                >
              </v-tooltip>

              <v-row>
                <v-col
                  v-for="item in props.items"
                  :key="item.message_name"
                  cols="12"
                  sm="4"
                  md="4"
                  lg="6"
                >
                  <v-card :color="checkItem(item)" class="p-1">
                    <v-card-title class="subheading font-weight-bold">
                      {{ item.message_name }}
                      <a
                        @click="redirect(item)"
                        class="ml-4 text-indigo-600 hover:text-indigo-900"
                      >
                        <svg
                          class="h-6 w-6 text-green-500"
                          viewBox="0 0 24 24"
                          stroke-width="2"
                          stroke="currentColor"
                          fill="none"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" />
                          <path
                            d="M9 7 h-3a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-3"
                          />
                          <path
                            d="M9 15h3l8.5 -8.5a1.5 1.5 0 0 0 -3 -3l-8.5 8.5v3"
                          />
                          <line x1="16" y1="5" x2="19" y2="8" />
                        </svg>
                      </a>

                      <div class="flex justify-end">
                        <span
                          v-if="item.message_type == 1"
                          class="inline-flex sm:hidden items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800"
                        >
                          SMS
                        </span>
                        <span
                          v-else
                          class="inline-flex sm:hidden items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
                        >
                          EMAIL
                        </span>
                        <span
                          class="inline-flex items-center "
                          v-if="item.repeating_message == 1"
                        >
                          <span
                            class="px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-900"
                          >
                            Repeating message
                          </span>
                          <span
                            v-if="item.repeats.length > 0"
                            @click="openRepeats = !openRepeats"
                            class="cursor-pointer"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              class="h-4 w-4"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              stroke-width="2"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
                              />
                            </svg>
                          </span>
                        </span>
                        <span
                          v-else
                          class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-500 text-gray-50"
                        >
                          Single Deliver
                        </span>
                      </div>
                    </v-card-title>
                    <v-card-subtitle class="hidden sm:block">
                      <span
                        v-if="item.message_type == 1"
                        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800"
                      >
                        SMS
                      </span>
                      <span
                        v-else
                        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
                      >
                        EMAIL
                      </span>
                    </v-card-subtitle>

                    <v-divider></v-divider>

                    <v-list dense>
                      <v-list-item>
                        <v-list-item-content>
                          <span class="text-gray-700 -ml-1">Tags Assigned</span>
                        </v-list-item-content>
                        <v-list-item-content>
                          <span
                            v-for="tag in item.tags"
                            :key="tag.id"
                            class="flex ml-1 text-center w-auto items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-pink-100 text-pink-800"
                          >
                            {{ tag.name }}
                            <span
                              class="ml-2  px-2 py-0.5 font-bold rounded-full text-xs bg-pink-300 text-pink-800"
                            >
                              {{ tag.users.length }} contacts
                            </span>
                          </span>
                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item
                        v-for="(key, index) in filteredKeys"
                        :key="index"
                      >
                        <v-list-item-content
                          :class="{ 'blue--text': sortBy === key }"
                        >
                          {{ key }}:
                        </v-list-item-content>
                        <v-list-item-content
                          class="align-end"
                          :class="{ 'blue--text': sortBy === key }"
                        >
                          <span
                            :class="formattingDate(item.deliver_date)"
                            v-if="key == 'deliver_date'"
                          >
                            {{ item[key.toLowerCase()] }}
                          </span>
                          <span v-else>
                            {{ item[key.toLowerCase()] }}
                          </span>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>

                    <v-card-actions v-if="openRepeats">
                      <div class="grid grid-cols-2 sm:grid-cols-3 gap-1">
                        <div v-for="deliver in item.repeats" :key="deliver.id">
                          <span
                            v-if="deliver.recurrent_day > actualDate"
                            class="sm:px-3 py-0.5 rounded-full text-sm font-light bg-green-100 text-green-800"
                          >
                            {{ deliver.recurrent_day }}
                          </span>

                          <span
                            v-else
                            class="sm:px-3 py-0.5 rounded-full text-sm font-light bg-red-100 text-red-800"
                          >
                            {{ deliver.recurrent_day }}
                          </span>
                        </div>
                      </div>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </template>

            <template v-slot:footer>
              <v-row class="mt-2" align="center" justify="center">
                <span class="grey--text">Items per page</span>
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      dark
                      text
                      color="primary"
                      class="ml-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ itemsPerPage }}
                      <v-icon>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(number, index) in itemsPerPageArray"
                      :key="index"
                      @click="updateItemsPerPage(number)"
                    >
                      <v-list-item-title>{{ number }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-spacer></v-spacer>

                <span
                  class="mr-4
                        grey--text"
                >
                  Page {{ page }} of {{ numberOfPages }}
                </span>
                <v-btn
                  fab
                  dark
                  color="blue darken-3"
                  class="mr-1"
                  @click="formerPage"
                >
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn
                  fab
                  dark
                  color="blue darken-3"
                  class="ml-1"
                  @click="nextPage"
                >
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>

                <button
                  @click="closingModal()"
                  type="button"
                  class="mt-3 mr-4 ml-4 inline-flex justify-center border rounded-md shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-100 focus:outline-none"
                >
                  Close
                </button>
              </v-row>
            </template>
          </v-data-iterator>
        </div>
      </div>
    </div>
  </div>
</template>

<script
  src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
  integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
  crossorigin="anonymous"
></script>
<script>
import Multiselect from "vue-multiselect";
import moment from "moment";
export default {
  components: { Multiselect },
  props: {
    source: String,
    messages: Array,
    tags: Array
  },

  data() {
    return {
      showTags: false,
      selectedMessage: false,
      picker2: new Date().toISOString().substr(0, 10),
      picker3: "",
      menu: false,
      dates: [new Date().toISOString().substr(0, 10)],
      menu2: false,
      messageRepeated: "",
      tagsSelected: [],
      messageSelected: "",
      openRepeats: false,
      actualDate: moment().format("YYYY-MM-DD"),

      itemsPerPageArray: [4, 8, 12],
      search: "",
      filter: {},
      sortDesc: false,
      page: 1,
      itemsPerPage: 4,
      sortBy: "name",
      keys: ["deliver_date"]
    };
  },

  filters: {
    shortText(value, limit) {
      if (value) {
        return value.substring(0, limit);
      }
    }
  },

  computed: {
    numberOfPages() {
      return Math.ceil(this.messages.length / this.itemsPerPage);
    },

    // filteredKeys () {
    //   return this.keys.filter(key => key !== 'Name')
    // },

    filteredKeys() {
      return this.keys.filter(key => key !== "Name");
    }
  },

  methods: {
    checkItem(item) {
      if (item.deliver_date == null && item.repeating_message == 0) {
        return "#EEEEEE";
      }
    },

    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    },

    typeMessage() {
      this.messages.filter(item => {
        if (item.message_type === 1) {
          return (this.messages = item);
        }
      });
    },

    formattingDate(value) {
      let now = moment.utc(new Date().toISOString()).format("YYYY-MM-DD HH:mm");
      let newDate = moment.utc(value).format("YYYY-MM-DD HH:mm");

      if (newDate > now) {
        this.showLat = false;
        return "text-orange-400";
      } else if (newDate == now) {
        this.showLat = true;
        return "text-green-500";
      } else {
        this.showLat = true;
        return "text-green-500";
      }
    },

    showMessage(item) {
      this.selectedMessage = true;
      this.messageSelected = item;
    },

    closeSelectedMessage() {
      this.selectedMessage = false;
      this.messageSelected = "";
    },

    messageUpdate(message) {
      let updateMessage = new FormData();

      $.each(this.tagsSelected, function(key, value) {
        updateMessage.append(`tagIds[${key}]`, value.id);
      });

      $.each(this.dates, function(key, value) {
        updateMessage.append(`dates[${key}]`, value);
      });

      updateMessage.append("messageId", message.id);
      updateMessage.append("picker2", this.picker3);
      updateMessage.append("messageRepeated", this.messageRepeated);

      window.axios.post("/api/updateMessage", updateMessage).then(() => {
        this.$emit("event");
        this.messageRepeated = "";
        this.picker3 = "";
      });
    },

    closingModal() {
      this.$emit("event");
    },

    redirect(message) {
      this.$router.push({ name: "CrmMessage", params: { id: message.id } });
    }
  }
};
</script>
